const safeSubmitProcessing = async (
  loading: any,
  payload: () => any,
  onSucces: (response?: any) => any,
  onFailure: (err?: any) => any
) => {
  loading.value = true
  try {
    const response = await payload()
    await onSucces(response)
  } catch (err) {
    onFailure(err)
  } finally {
    loading.value = false
    scrollToFirstError()
  }
}

const setLocalStorageKey = (key: string, value: string) => {
  try {
    localStorage.setItem(key, value)
  } catch {
    // ignore if localStorage is not available
  }
}

const getLocalStorageKey = (key: string) => {
  try {
    return localStorage.getItem(key)
  } catch {
    // ignore if localStorage is not available
  }
}

const fetchLocalStorageKey = (key: string) => {
  try {
    const value = localStorage.getItem(key)
    localStorage.removeItem(key)
    return value
  } catch {
    // ignore if localStorage is not available
  }
}

const removeLocalStorageKey = (key: string) => {
  try {
    localStorage.removeItem(key)
  } catch {
    // ignore if localStorage is not available
  }
}

const scrollToFirstError = () => {
  setTimeout(() => {
    const error = document.getElementsByClassName('is-error')[0]
    if (error) {
      ;(error.parentNode as HTMLElement).scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest'
      })
    }
  }, 150)
}

const deepClone = (obj: any) => {
  return JSON.parse(JSON.stringify(obj))
}

const darkTheme = /theme=dark/.test(window.location.search) ? 'dark' : null

export {
  safeSubmitProcessing,
  setLocalStorageKey,
  getLocalStorageKey,
  removeLocalStorageKey,
  scrollToFirstError,
  deepClone,
  fetchLocalStorageKey,
  darkTheme
}
